import { useEffect, useState } from 'react';
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  Alert,
  AlertDescription,
  AlertTitle,
  Button,
  Skeleton,
  cn,
  toast,
  IconLucide
} from '@yakit/ui-components';
import { LoaderCircle } from 'lucide-react';

import { useVDLModalStore } from '@VDL/store/VDLModalStore';
import { putSubmitPassport } from '@VDL/api';
import { useFetchPassportIframe } from '@VDL/hooks/useFetchPassportIframe';

export const VDLPassportModal = () => {
  const [iframeLoaded, setIframeLoaded] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { passportModal, setPassportModal } = useVDLModalStore();

  const { iframe, loading, fetchIframe, error } = useFetchPassportIframe();

  useEffect(() => {
    if (passportModal?.code) {
      fetchIframe(passportModal.code);
    }
  }, [passportModal?.code, fetchIframe]);

  const handleSubmit = async () => {
    if (!passportModal) throw new Error('passportModal is not defined');

    setIsSubmitting(true);
    try {
      putSubmitPassport(passportModal.code);

      toast.success('Успешно согласовано');
    } catch (error) {
      toast.error('Не удалось отправить на согласование');
      console.log(error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Dialog
      open={!!passportModal?.code}
      onOpenChange={(flag) => {
        if (!flag) {
          setPassportModal(null);
        }
      }}
    >
      <DialogContent className="flex h-[90dvh] w-[90dvw] flex-col sm:max-w-[90dvw]">
        <DialogHeader className="shrink-0">
          <DialogTitle>Паспорт</DialogTitle>
        </DialogHeader>
        <div className="relative flex-1">
          <div className="absolute h-full w-full">
            {loading && (
              <Skeleton className="flex h-full w-full items-center justify-center">
                <div className="flex flex-col items-center gap-3 text-muted-foreground text-sm">
                  Загрузка паспорта...
                  <IconLucide
                    name="LoaderCircle"
                    className="h-4 w-4 animate-spin mt-0.5"
                  />
                </div>
              </Skeleton>
            )}
            {!loading && iframe && (
              <iframe
                className={cn('absolute h-full w-full', {
                  hidden: !iframeLoaded
                })}
                src={iframe}
                onLoad={() => setIframeLoaded(true)}
              />
            )}
            {error && (
              <div className="flex h-full w-full items-start justify-center lg:items-center">
                <Alert className="text-destructive max-w-lg">
                  <AlertTitle>Не удалось загрузить паспорт</AlertTitle>
                  <AlertDescription>
                    Произошла ошибка при запросе
                  </AlertDescription>
                </Alert>
              </div>
            )}
          </div>
        </div>
        <DialogFooter>
          <Button onClick={handleSubmit} disabled={isSubmitting || loading || error != null}>
            {isSubmitting ? (
              <span className="flex items-center gap-2">
                Отправляем на согласование
                <LoaderCircle className="ml-2 h-4 w-4" />
              </span>
            ) : (
              'Отправить на согласование'
            )}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
